// extracted by mini-css-extract-plugin
export default {"products":"free_products__Odv+F","card":"free_card__ewufD","rate":"free_rate__k2c--","stars":"free_stars__F+Ncv","name":"free_name__sqvK7"};